"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Adjustments_1 = __importDefault(require("./chargemethod/Adjustments"));
const Assemblies_1 = __importDefault(require("./chargemethod/Assemblies"));
const Receiving_1 = __importDefault(require("./chargemethod/Receiving"));
const Returns_1 = __importDefault(require("./chargemethod/Returns"));
const Shipping_1 = __importDefault(require("./chargemethod/Shipping"));
class ChargeMethodValidator {
    shipping;
    receiving;
    returns;
    adjustments;
    assemblies;
    constructor() {
        this.shipping = new Shipping_1.default();
        this.receiving = new Receiving_1.default();
        this.returns = new Returns_1.default();
        this.adjustments = new Adjustments_1.default();
        this.assemblies = new Assemblies_1.default();
    }
}
exports.default = ChargeMethodValidator;
